<template>
  <div class="topList">
    <div class="topleft">
      <div class="group">
        <div class="title">楼</div>
        <a-select v-model="floorVal" @change="floorChange" style="width: 160px">
          <a-select-option v-for="item in floorData" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="group">
        <div class="title">层</div>
        <a-select v-model="layerVal" @change="layerChange" style="width: 160px">
          <a-select-option v-for="item in layerData" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div class="topright">
      <a-input-search
        v-model:value="searchValue"
        placeholder="请输入关键字"
        style="width: 150px"
        @pressEnter="onSearch"
        @search="onSearch"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchValue: '',
      floorVal: '',
      floorData: [
        {
          name: '全部',
          id: '',
        },
      ],
      layerVal: '',
      layerData: [
        {
          name: '全部',
          id: '',
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getSelectData();
  },
  methods: {
    floorChange() {
      this.layerVal = '';
      (this.layerData = [
        {
          name: '全部',
          id: '',
        },
      ]),
        this.getSelectData(1);
      this.$emit('searchRoom', this.floorVal, this.layerVal, this.searchValue);
    },
    layerChange() {
      this.$emit('searchRoom', this.floorVal, this.layerVal, this.searchValue);
    },
    onSearch() {
      this.$emit(
        'searchRoom',
        this.floorVal,
        this.layerVal,
        this.searchValue,
        true
      );
    },
    getSelectData(data = '') {
      let params = {
        buildingId: '',
      };
      if (data) {
        params.buildingId = this.floorVal;
      }

      this.$get(
        '/api/v3/bed/getBuildList',
        params,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              if (!data) {
                this.floorData = this.floorData.concat(res.data.buildList);
                console.log(this.floorData);
              } else {
                this.layerData = this.layerData.concat(res.data.floorList);
              }
            } else {
            }
          } else {
          }
        },
        (err) => {
          //console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.topList {
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
  .topleft {
    display: flex;
    .group {
      display: flex;
      margin-right: 20px;
      .title {
        font-size: 24px;
        color: #262626;
        line-height: 32px;
        margin-right: 10px;
      }
    }
  }
}
</style>
